/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'./DashboardToExploreConverter'
], function( DashboardToExploreConverter) {
	class StoryToExploreConverter extends DashboardToExploreConverter {
		constructor(definition) {
			super(Object.assign({
				src: 'STORY',
				target: 'EXPLORE'
			}, definition));
		}
		convert(src, target, spec) {
			return super.convert(src, target, spec).then(spec => {
				const specJson = JSON.parse(spec);
				if (!this.validate(specJson)) {
					// if the spec is null at this point we have nothing to do.
					return spec;
				}
				return JSON.stringify(this._doConversion(specJson));
			});
		}

		_doConversion(spec){
			delete spec.episodes;
			return spec;
		}
	}
	return StoryToExploreConverter;
});
